<template>
  <div>
    <div class="d-flex align-items-center row rounded py-2 objective-item">
      <div v-if="!readOnly" class="col-1 mw-50">
        <i class="fa fa-bars fa-lg objective-item-icon cursor-pointer"></i>
      </div>
      <div class="col" :class="{ 'px-4': readOnly }">
        {{ areaIndex + 1 }}.{{ index + 1 }}
        {{ objective.title }}
      </div>
      <div class="col-1" :class="{ 'mx-3': readOnly }">
        <div
          class="rounded text-center py-2"
          :style="{ backgroundColor: objective.color }"
        >
          {{ objective.level }}
        </div>
      </div>
      <div v-if="!readOnly" class="col-1 text-right">
        <i class="far fa-times text-danger cursor-pointer" @click="quit"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TransitionStudentObjectives",
  props: {
    areaIndex: {
      type: Number,
      dafault: () => 0
    },
    index: {
      type: Number,
      dafault: () => 0
    },
    objective: {
      type: Object,
      dafault: () => ({})
    },
    readOnly: {
      type: Boolean,
      dafault: () => false
    }
  },
  methods: {
    quit() {
      this.$emit("quit", this.objective);
    }
  }
};
</script>
<style scoped lang="scss">
.objective-item {
  background-color: #f7f7f7;
}
.objective-item-icon {
  color: #d0d0d0;
}
.mw-50 {
  max-width: 50px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
